import { useLocation } from 'react-router-dom';
import { CalendarDays, ClipboardList, Crown, Users } from 'lucide-react';
import { useApplicants } from '../contexts/ApplicantsContext';
import { isOpen } from '../utils/applicant';
import { tiers } from '../data/tiers';
import type { LucideIcon } from 'lucide-react';
import { useEvents } from '../contexts/EventsContext';
import { experts } from '../data/experts';
import { isAwaiting } from '../utils/event';

export type NavItem = {
  to: string;
  label: string;
  description: string;
  icon: LucideIcon;
  count: number;
  alert?: number;
  active: boolean;
};

export function useNavItems(): NavItem[] {
  const { pathname } = useLocation();
  const { events } = useEvents();
  const { applicants } = useApplicants();
  const awaiting = events.reduce((s, e) => s + e.invitations.filter((i) => isAwaiting(i.status)).length, 0);

  return [
    {
      to: '/',
      label: 'Experts',
      description: 'Directory & profiles',
      icon: Users,
      count: experts.length,
      active: pathname === '/' || pathname.startsWith('/experts'),
    },
    {
      to: '/applicants',
      label: 'Applicants',
      description: 'Pending review',
      icon: ClipboardList,
      count: applicants.filter((a) => isOpen(a.status)).length,
      alert: applicants.filter((a) => a.status === 'New').length,
      active: pathname.startsWith('/applicants'),
    },
    {
      to: '/events',
      label: 'Events',
      description: 'Organize & invite',
      icon: CalendarDays,
      count: events.length,
      alert: awaiting,
      active: pathname.startsWith('/events'),
    },
    {
      to: '/tiers',
      label: 'Tiers',
      description: 'Levels & privileges',
      icon: Crown,
      count: tiers.length,
      active: pathname.startsWith('/tiers'),
    },
  ];
}
